import { Lang, VoiceBotOptions, ProjectInterface } from "./types";
import { isProduction } from "../../util/constants";

export const PROJECT_LIST: ProjectInterface[] = !isProduction()
    ? [
          {
              key: "dev-v1",
              label: "Shop24 (v1-dev)",
              versionEndpoint: "v1-dev",
              isProtected: false,
              defaultLang: Lang.EN,
          },
          {
              key: "dev-v2",
              label: "Call Simulator (v2-dev)",
              versionEndpoint: "v2-dev",
              isProtected: false,
              defaultLang: Lang.DE,
              isRealtime: true,
          },
          {
              key: "dev-v3",
              label: "Shop24 (v3-dev)",
              versionEndpoint: "v3-dev",
              isProtected: false,
              defaultLang: Lang.EN,
              isRealtime: true,
          },
      ]
    : [
          {
              key: "prod-v1",
              label: "Shop24 (v1)",
              versionEndpoint: "v1",
              isProtected: true,
              defaultLang: Lang.DE,
          },
          {
              key: "prod-v2",
              label: "Call Simulator (v2)",
              versionEndpoint: "v2",
              isProtected: true,
              defaultLang: Lang.DE,
          },
      ];

export const languages: Lang[] = [Lang.EN, Lang.DE];

export const voices: Record<string, string> = {
    "": "Default",
    "en-US-AvaMultilingualNeural": "Ava",
    "en-US-NovaTurboMultilingualNeural": "Nova",
    "de-DE-SeraphinaMultilingualNeural": "Seraphina (DE)",
    "en-US-AriaNeural": "Aria (EN only)",
    "en-US-AlloyTurboMultilingualNeural": "Alloy",
};

export const realtimeVoices: Record<string, string> = {
    alloy: "Alloy",
    ash: "Ash",
    ballad: "Ballad",
    coral: "Coral",
    echo: "Echo",
    sage: "Sage",
    shimmer: "Shimmer",
    verse: "Verse",
};

export const voicesStyles: Record<string, string[]> = {
    "en-US-AriaNeural": [
        "angry",
        "chat",
        "cheerful",
        "customerservice",
        "empathetic",
        "excited",
        "friendly",
        "hopeful",
        "narration-professional",
        "newscast-casual",
        "newscast-formal",
        "sad",
        "shouting",
        "terrified",
        "unfriendly",
        "whispering",
    ],
};

export const chatBotDefaultOptions: VoiceBotOptions = {
    lang: Lang.EN,
    voice: "",
    speed: 1,
    style: "",
    ttsInstructions: "",
    vadThreshold: 0.7,
    isRealtime: false,
    instructions: "",
    greeting: "",
    defaultInstruction: "",
    temperature: 1,
    vadMinNonSpeech: 2000,
    vadMinUtterance: 400,
    vadMaxUtterance: 30000,
};

// Audio configuration constants
export const AUDIO_CONFIG = {
    SPEED_MIN: 0.1,
    SPEED_MAX: 2.0,
    SPEED_STEP: 0.1,
    SPEED_COUNT: 20,
    DECODER_CHANNELS: 1,
    DECODER_SAMPLE_RATE: 16000,
    PLAYER_FLUSHING_TIME: 1000,
    RECORDER_FRAME_SIZE: 60,
    RECORDER_MAX_FRAMES: 4,
} as const;

// WebSocket configuration constants
export const WS_CONFIG = {
    CLOSE_CODE_NORMAL: 1000,
    CONFIG_UPDATE_DELAY: 50,
    RECONNECT_DELAY: 50,
} as const;

// UI configuration constants
export const UI_CONFIG = {
    DEBOUNCE_DELAY: 1000,
    FADE_SAMPLES: 50,
} as const;

export const promptBlockCategories = [
    { label: "Lang Instruction", color: "#1976d2" }, // Instructions related to language, tone, or style
    { label: "Core Topics", color: "#dc004e" }, // Main subjects or themes for the prompt
    { label: "Do Say", color: "#2e7d32" }, // Specific phrases, words, or styles to include
    { label: "Don't Say", color: "#ed6c02" }, // Words, tones, or phrases to avoid
    { label: "Style Vibes", color: "#d32f2f" }, // Descriptions of the style, mood, or formatting
    { label: "Examples Zone", color: "#0288d1" }, // Example inputs or outputs for better context
    { label: "Constraints", color: "#9e9e9e" }, // Limitations like word count, structure, or formats
];

export function getColorByLabel(label: string): string {
    const category = promptBlockCategories.find((cat) => cat.label === label);
    return category ? category.color : "#606060"; // Returns null if label is not found
}
